import cn from 'classnames';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { ChatCapsulePreview } from '@/services/chatApi';
import { getMediaUrl } from '@/utils/mediaUrl';
import { displayName } from '@/utils/chat';
import styles from './M_ChatCapsuleSuggestion.module.css';

interface M_ChatCapsuleSuggestionProps {
  capsule: ChatCapsulePreview;
  isActive?: boolean;
  onSelect: (capsule: ChatCapsulePreview) => void;
  /** Подсветка активного варианта при навигации с клавиатуры. */
  onHover?: () => void;
}

export default function M_ChatCapsuleSuggestion({
  capsule,
  isActive = false,
  onSelect,
  onHover,
}: M_ChatCapsuleSuggestionProps) {
  const image = capsule.imagePreview || capsule.image;

  return (
    <button
      type='button'
      className={cn(styles.wrapper, { [styles.active]: isActive })}
      onMouseEnter={onHover}
      // mousedown вместо click: поле ввода не должно потерять фокус до выбора.
      onMouseDown={event => {
        event.preventDefault();
        onSelect(capsule);
      }}
    >
      <div className={styles.thumb}>
        {image ? (
          <img src={getMediaUrl(image)} alt='' />
        ) : (
          <Q_Icon.CapsIcon width={20} height={20} fill='none' />
        )}
      </div>
      <div className={styles.body}>
        <span className={cn(styles.title, 'text-p-8')}>{capsule.title}</span>
        <span className={cn(styles.author, 'text-caption')}>
          {displayName(capsule.author)}
        </span>
      </div>
    </button>
  );
}
